"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importStar(require("styled-components"));
const bridge_1 = require("@completeanatomy/bridge");
const ui_1 = require("@completeanatomy/ui");
const hooks_1 = require("../../hooks");
const molecules_1 = require("../../molecules");
function BreadcrumbTrail({ onItemSelect, style, className, }) {
    const bridge = (0, bridge_1.useBridge)();
    const breadcrumbTrailState = (0, hooks_1.useBreadcrumbTrailState)();
    const buttons = (0, react_1.useRef)([]);
    const container = (0, react_1.useRef)(null);
    const scrollView = (0, react_1.useRef)(null);
    const [itemsList, setItemsList] = (0, react_1.useState)([]);
    const prevStyleRef = (0, react_1.useRef)();
    const updateLayout = () => {
        if (buttons.current.length === 0 || !container.current) {
            return;
        }
        let xCoords = [];
        const SPACE_BETWEEN_ELEMENTS = 5;
        let x = SPACE_BETWEEN_ELEMENTS;
        xCoords = buttons.current.reduce((acc, button, index) => {
            button.style.transform = `translateX(${x}px)`;
            button.style.opacity = '1';
            x += button.offsetWidth + SPACE_BETWEEN_ELEMENTS;
            acc[index] = x;
            return acc;
        }, []);
        container.current.style.maxWidth = `${xCoords === null || xCoords === void 0 ? void 0 : xCoords.pop()}px`;
    };
    const handleClick = (item, index) => {
        bridge === null || bridge === void 0 ? void 0 : bridge.selectBreadcrumbTrailItemAtIndex(index);
        if (onItemSelect) {
            onItemSelect(item);
        }
    };
    /**
     * @todo Remove when native side will return array
     */
    const getBreadcrumbsArray = (breadcrumbArray) => {
        if (breadcrumbArray && !Array.isArray(breadcrumbArray)) {
            return Object.values(breadcrumbArray);
        }
        return breadcrumbArray;
    };
    (0, react_1.useEffect)(() => {
        const breadcrumbTrailArray = getBreadcrumbsArray(breadcrumbTrailState);
        if (breadcrumbTrailArray && !!breadcrumbTrailArray.length) {
            setItemsList(breadcrumbTrailArray);
        }
        else {
            setTimeout(() => {
                setItemsList([]);
            }, 300);
        }
    }, [breadcrumbTrailState]);
    const onWheel = (event) => {
        event.preventDefault();
        event.currentTarget.scrollLeft += event.deltaY;
    };
    const scrollToSelectedItem = (0, react_1.useCallback)(() => {
        const selectedIndex = itemsList.findIndex(item => item.isSelected);
        if (selectedIndex !== -1 && buttons.current[selectedIndex]) {
            buttons.current[selectedIndex].scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'nearest',
            });
        }
    }, [itemsList]);
    const onEntered = () => {
        setTimeout(() => {
            scrollToSelectedItem();
        }, 300);
    };
    (0, react_1.useEffect)(() => {
        updateLayout();
        scrollToSelectedItem();
    }, [itemsList, scrollToSelectedItem]);
    (0, react_1.useEffect)(() => {
        if (JSON.stringify(prevStyleRef.current) !== JSON.stringify(style)) {
            scrollToSelectedItem();
        }
        prevStyleRef.current = style;
    }, [style, scrollToSelectedItem]);
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: breadcrumbTrailState && !!breadcrumbTrailState.length, appear: true, timeout: 200, mountOnEnter: true, unmountOnExit: true, onEntered: onEntered, "data-e2e": 'BreadcrumbTrail_CSSTransition', children: (0, jsx_runtime_1.jsx)(Container, { ref: container, className: className, "data-e2e": 'BreadcrumbTrail_Container', children: (0, jsx_runtime_1.jsx)(ScrollView, { ref: scrollView, style: style, onWheel: onWheel, "data-e2e": 'BreadcrumbTrail_ScrollView', children: itemsList.map((item, index) => ((0, jsx_runtime_1.jsx)(molecules_1.BreadcrumbTrailElement, { name: item.name, selected: item.isSelected, onClick: () => handleClick(item, index), getButtonElement: itemRef => {
                        buttons.current[index] = itemRef;
                    }, "data-e2e": 'BreadcrumbTrail_BreadcrumbTrailElement' }, index))) }) }) }));
}
exports.default = (0, bridge_1.withBridgeProvider)(BreadcrumbTrail);
const Container = styled_components_1.default.div `
  width: 100%;
  height: 44px;
  padding: 5px 0;
  margin-top: 4px;

  pointer-events: none;

  transition: transform 0.2s ease-in-out, opacity 0.2s ease-in-out;

  &.enter,
  &.appear {
    transform: translateY(-100%);
    opacity: 0;
    z-index: -1;
  }

  &.enter-active,
  &.appear-active {
    transform: translateY(0);
    opacity: 1;
  }

  &.enter-done,
  &.appear-active {
    transform: translateY(0);
    opacity: 1;
  }

  &.exit-active {
    transform: translateY(-100%);
    opacity: 0;
    z-index: -1;
  }
`;
const ScrollView = styled_components_1.default.div `
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  flex-shrink: 1;

  position: relative;

  width: 100%;
  height: 100%;
  max-height: 100%;

  overflow: initial;
  overflow-x: auto;
  overflow-y: hidden;

  pointer-events: initial;

  &::-webkit-scrollbar {
    display: block;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background-color: inherit;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.grasshopper.descriptionPanel.scroll.idle};
    border-radius: 6px;
  }

  &::-webkit-scrollbar-thumb:hover {
    opacity: 0.8;
  }

  ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
    &::-webkit-scrollbar {
      display: none;
    }
  `)};
`;
